import React from "react";

function ContactBoxBadge(data) {
  return (
    <div className="badge badge--gray">{data.badge}</div>
  );
}
export default ContactBoxBadge;